// extracted by mini-css-extract-plugin
export default {"header":"ShareAction_header__40w9Q"};